// React
import { useContext } from "react"

// Components
import { Select, Textarea } from "components"

// Contexts
import { DisabledContext } from "../contexts"

// Form
import { Controller, useFormContext } from "react-hook-form"

// Utils
import { generateAddress, useLocation } from "utils"

export function Deliver(params: {
  disabled?: boolean
  deliver_name: string
  detail_name: string
}) {
  // Hooks
  const disabled = useContext(DisabledContext)
  const { data, isLoading } = useLocation()

  // Form
  const { control, setValue, clearErrors } = useFormContext()

  return (
    <section>
      <Controller
        name={params.deliver_name}
        control={control}
        render={({ field, fieldState }) => (
          <Select
            label="DELIVER TO"
            placeholder="Select Deliver"
            error={fieldState.error?.message}
            isDisabled={params.disabled || disabled}
            isLoading={isLoading}
            options={data}
            ref={field.ref}
            value={data.find(item => item.value === field.value) ?? null}
            onChange={(e: any) => {
              if (e) {
                field.onChange(e.value)
                setValue(params.detail_name, generateAddress(e))
                clearErrors(params.detail_name)
              }
            }}
          />
        )}
      />

      <Controller
        control={control}
        name={params.detail_name}
        render={({ field, fieldState }) => (
          <Textarea
            {...field}
            disabled={params.disabled || disabled}
            error={fieldState.error?.message}
          />
        )}
      />
    </section>
  )
}